import React, { useLayoutEffect } from 'react';
import {
  PageContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  ButtonStyled,
  TooltipWrapper,
  StyledList,
  StyledLi,
  StyledSubtitle,
  DateSubtitle,
  TwoColumnImage,
} from './Hikes.styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const GoryStolowe2026: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schedule = t('goryStolowe.schedule', { returnObjects: true }) as string[];
  const included = t('goryStolowe.included', { returnObjects: true }) as string[];
  const extra = t('goryStolowe.extra', { returnObjects: true }) as string[];

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.goryStolowe2026')}</Title>
          <DateSubtitle>
            {t('hiking.date-goryStolowe2026')} | {t('hiking.seats-goryStolowe2026')}
          </DateSubtitle>
          <Text>{t('hiking.destination-goryStolowe2026')}</Text>

          <StyledSubtitle>{t('goryStolowe.subtitleDescription')}</StyledSubtitle>
          <Text>{t('goryStolowe.description1')}</Text>
          <Text>{t('goryStolowe.description2')}</Text>
          <Text>{t('goryStolowe.description3')}</Text>
          <Text>{t('goryStolowe.description4')}</Text>

          <StyledSubtitle>{t('goryStolowe.subtitleStay')}</StyledSubtitle>
          <Text>{t('goryStolowe.stay1')}</Text>
          <Text>{t('goryStolowe.stay2')}</Text>
          <Text>{t('goryStolowe.stay3')}</Text>

          <Text style={{ marginBottom: '5px' }}>
            <strong>{t('goryStolowe.scheduleTitle')}</strong>
          </Text>
          <StyledList>
            {schedule.map((item) => (
              <StyledLi key={item}>{item}</StyledLi>
            ))}
          </StyledList>

          <Text style={{ marginBottom: '5px' }}>
            <strong>{t('goryStolowe.includedTitle')}</strong>
          </Text>
          <StyledList>
            {included.map((item) => (
              <StyledLi key={item}>{item}</StyledLi>
            ))}
          </StyledList>

          <Text style={{ marginBottom: '5px' }}>
            <strong>{t('goryStolowe.extraTitle')}</strong>
          </Text>
          <StyledList>
            {extra.map((item) => (
              <StyledLi key={item}>{item}</StyledLi>
            ))}
          </StyledList>

          <TooltipWrapper>
            <ButtonStyled
              type="button"
              data-tooltip={t('goryStolowe.signUpTooltip')}
              onClick={() => {
                navigate('/contact');
                window.scrollTo(0, 0);
              }}
            >
              {t('button.register')}
            </ButtonStyled>
          </TooltipWrapper>

          <TwoColumnImage
            src="/images/g_stolowe.webp"
            alt={t('goryStolowe.imageAlt')}
            style={{ margin: '30px 0 10px 0' }}
          />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};

export default GoryStolowe2026;
